<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">系统参数<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
            </div>
            <div class="content-input-item">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
          </div>
          <div class="content-input-right">

          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editSysParamDialog(-1)" size="default">添加</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="name" label="名称" v-if="checkColList.indexOf('名称') > -1"/>
            <el-table-column property="keyCode" label="参数代码" v-if="checkColList.indexOf('参数代码') > -1"/>
            <el-table-column property="description" label="参数说明" v-if="checkColList.indexOf('参数说明') > -1"/>
            <el-table-column property="config" label="配置" v-if="checkColList.indexOf('配置') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
<!--                <el-space direction="vertical">-->
                  <el-button @click="editSysParamDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
<!--                </el-space>-->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getSysParamPageList} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import ImgViewer from "@/assets/js/imageViewer";
import ShopConfigDialog from "@/views/shop/components/ShopConfigDialog";
import SysParamDialog from "@/views/setting/components/SysParamDialog";

export default {
  name: "SysParam",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      // shopIdArray: [
      //   {name: '不限', id: 0},
      // ],
      // shopIdArr:[],
      // shopId: 0,


      //刷新组
      colList: ['创建时间', '名称', '参数代码', '参数说明', '配置', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '参数名称', value : 1},
        {label : '参数代码', value : 2},
        {label : '参数说明', value : 3},
        {label : '参数配置', value : 4},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysParamPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editSysParamDialog(idx, row) {
      let _title = '';
      let paramForm = {}
      if (idx > -1) {
        _title = '编辑系统参数'
        paramForm = Object.assign({}, row);
        // console.log(shopForm)
      }else {
        _title = '添加系统参数'
        // console.log(shopForm)
      }
      Dialog.open({
        title: _title,
        component: SysParamDialog,
        data: {
          paramForm: paramForm,
          ids: idx,
          width: '600px',
        },
        confirm: (result) => {
          row.name = result.name
          row.keyCode = result.keyCode
          row.config = result.config
          row.description = result.description
        }
      })
    },


    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },


  },
  mounted() {
    // let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    // this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
